export const DEFAULT_PAGE_SIZES = [20, 50, 100]
export const DEFAULT_PAGE_LAYOUT = 'total, sizes, prev, pager, next, jumper'

export enum YES_OR_NO {
  YES = 'Y',
  NO = 'N',
}

export enum PUB_SUB {
  FILE = 'FILE',
  LIST_STATUS = 'LIST_STATUS',
  LIST_UPLOAD_STATUS = 'LIST_UPLOAD_STATUS',
  CLEAN_FILE = 'CLEAN_FILE',
  STOP_FILE = 'STOP_FILE',
}

export enum FormTypeEnum {
  INPUT = 'INPUT',
  TEXTAREA = 'TEXTAREA',
  INPUT_NUMBER = 'INPUT_NUMBER',
  RADIO = 'RADIO',
  SELECT = 'SELECT',
  SELECT_GROUP = 'SELECT_GROUP',
  CHECKBOX = 'CHECKBOX',
  TREE = 'TREE',
  DATE_PICKER = 'DATE_PICKER',
  DATE_PICKER_WEEK = 'DATE_PICKER_WEEK',
  DATE_PICKER_YEAR = 'DATE_PICKER_YEAR',
  DATE_PICKER_MONTH = 'DATE_PICKER_MONTH',
  DATE_PICKER_DATERANGE = 'DATE_PICKER_DATERANGE',
  DATE_PICKER_MONTHRANGE = 'DATE_PICKER_MONTHRANGE',
  DATE_PICKER_DATETIME = 'DATE_PICKER_DATETIME',
  DATE_PICKER_DATETIMERANGE = 'DATE_PICKER_DATETIME',
}

export enum RoleTypeEnum {
  Dealer = 'CREATER_DEALER',
  Parts = 'ROLE_CN_SUPORT',
  Helpdesk = 'ROLE_RSD',
  CallCenter = 'CREATER_CALL_CENTER',
  TIPS_DEALER = 'TIPS_DEALER',
  TIPS_ADMIN = 'TIPS_ADMIN',
  TSEngineer = 'TS_ENGINEER',
  TSManager = 'TS_MANAGER',
  Coordinator = 'TIPS_COORDINATOR',
  Manager = 'TIPS_BU_E4',

  FTSEngineer = 'FTS_ENGINEER',
  RSDAdministrator = 'IT_RSD',
}

export enum AGREEMENT {
  SHIELD_PLATFORM_USE_PROTOCOL = 'SHIELD-PLATFORM-USE-PROTOCOL',
  SHIELD_PLATFORM_USER_PRIVACY_POLICY = 'SHIELD-PLATFORM-USER-PRIVACY-POLICY',
  SHIELD_PLATFORM_DEALER_OPERATION_MANUAL = 'SHIELD-PLATFORM-DEALER_OPERATION_MANUAL',
  SHIELD_PLATFORM_DEALER_APPLICATION_FORM = 'SHIELD-PLATFORM-DEALER-APPLICATION-FORM',
}

export const LOCALSTORAGE_KEYS = {
  ORG: `${import.meta.env.VITE_APP_NAME}_ORG`,
  ROLE: `${import.meta.env.VITE_APP_NAME}_ROLE`,
  TOKEN: `${import.meta.env.VITE_APP_NAME}_TOKEN`,
  LOCALE: `${import.meta.env.VITE_APP_NAME}_LOCALE`,
  SYSTEM: `${import.meta.env.VITE_APP_NAME}_SYSTEM`,
  REDIRECT: `${import.meta.env.VITE_APP_NAME}_REDIRECT`,
}

export enum INFO_ENUM {
  DEPARTMENT_ID = 'DEPARTMENT_ID',
  ROLE_ID = 'ROLE_ID',
}

export const FILE_TYPES = [
  '.pdf',
  '.wav',
  '.mov',
  '.mp4',
  '.wmv',
  '.mp3',
  '.jpg',
  '.jpeg',
  '.png',
  '.gif',
  '.zip',
  '.rar',
  '.7z',
  '.doc',
  '.docx',
  '.xlsx',
  '.xls',
  '.pptx',
  '.ppt',
  '.mpg',
  '.ai',
  '.psd',
  '.tif',
  '.tiff',
]

export const TIF_TYPES = ['.tif', '.tiff']
